export default __webpack_public_path__ + "static/media/strategy.ea947bd1.svg";